import { NavigationGuardNext, Route } from 'vue-router';
import { getInstance } from '@/auth';
import { hasAllPermissions } from '@/services/PermissionService';
import { PermissionType } from '@/auth/permission';
import { authMod } from '@/store/modules/auth';
import { ErrorCode } from '@/components/ErrorPage.vue';

export async function authRouterGuard(to: Route, from: Route, next: any) {
  const authService = getInstance();

  const fn = async () => {
    unwatch && unwatch();

    if (authService.isAuthenticated) {
      if (authMod.getPermissions.length < 1) {
        await authService.setUserPermission();
      }
      next();
    } else if (to.meta?.isPublic) {
      next();
    } else if (authService.errorCode === 'invalid_organisation') {
      next({ name: 'errorRoute', params: { code: ErrorCode.InvalidOrganisation.toString() } });
    } else {
      authService.loginWithRedirect({
        appState: { targetUrl: to.fullPath }
      });
    }
  };

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return await fn();
  }

  // Watch for the loading property to change before we check isAuthenticated
  const unwatch = authService.$watch('loading', async (loading: boolean) => {
    if (loading === false) {
      return await fn();
    }
  });
}

export function permissionRouterGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  if (to.meta?.isPublic) {
    next();
  } else {
    const requiredPermission = [PermissionType.appAccess, to.meta?.permission].filter((p) => p);

    if (!hasAllPermissions(requiredPermission)) {
      next({ name: 'errorRoute', params: { code: ErrorCode.NotAuthorized.toString() } });
    } else {
      next();
    }
  }
}
